import * as React from "react";
const SvgFiRrRampLoading = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M18.997 24H5.003a2.98 2.98 0 0 1-2.553-1.423 2.98 2.98 0 0 1-.131-2.919l2.724-5.447A3.98 3.98 0 0 1 8.62 12h6.758c1.525 0 2.896.847 3.578 2.211l2.724 5.447a2.98 2.98 0 0 1-.131 2.919A2.98 2.98 0 0 1 18.997 24M8.62 14c-.763 0-1.448.423-1.79 1.105l-2.723 5.447a.98.98 0 0 0 .044.973.98.98 0 0 0 .85.474h13.995a.99.99 0 0 0 .85-.474.98.98 0 0 0 .045-.973l-2.724-5.447A1.99 1.99 0 0 0 15.378 14zM22 12V5c0-2.757-2.243-5-5-5H7C4.243 0 2 2.243 2 5v7a1 1 0 1 0 2 0V5c0-1.654 1.346-3 3-3h10c1.654 0 3 1.346 3 3v7a1 1 0 1 0 2 0"
    />
  </svg>
);
export default SvgFiRrRampLoading;
